import { render, staticRenderFns } from "./SpeedDial.vue?vue&type=template&id=3f34da89"
import script from "./SpeedDial.vue?vue&type=script&lang=js"
export * from "./SpeedDial.vue?vue&type=script&lang=js"
import style0 from "./SpeedDial.vue?vue&type=style&index=0&id=3f34da89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports